import { api } from './api';
import { BACKEND_URL as BACKEND } from './config';
import { getAccessToken } from './session';

export type MissingProgrammeStatus = 'manquant' | 'echec_ocr';

export interface MissingProgrammeNote {
  entree_en_vigueur: string | null;
  impact_enseignant: string | null;
  updated_at: string | null;
}

export interface MissingProgrammeRow {
  url: string;
  nature: string | null;
  first_detected_at: string;
  source_run_id: string;
  status: MissingProgrammeStatus;
  raison: string;
  document_id: string | null;
  note: MissingProgrammeNote;
}

export interface NatureSummary {
  programme: number;
  accompagnement: number;
  indetermine: number;
  total: number;
}

export async function listMissingProgrammes(): Promise<{ items: MissingProgrammeRow[]; natureSummary: NatureSummary }> {
  return (await api.missingProgrammes.list.query()) as { items: MissingProgrammeRow[]; natureSummary: NatureSummary };
}

export async function saveMissingProgrammeNote(
  url: string,
  patch: { entreeEnVigueur: string | null; impactEnseignant: string | null },
): Promise<void> {
  await api.missingProgrammes.saveNote.mutate({ url, ...patch });
}

/** Dépose un PDF pour combler un texte manquant (ou un import ad hoc si
 *  `sourceUrl` est omis). Même route que l'import par URL, corps multipart. */
export async function ingestFile(file: File, sourceUrl?: string): Promise<{ id: string; title: string; page_count: number }> {
  const token = await getAccessToken();
  if (!token) throw new Error('Not authenticated');
  const form = new FormData();
  form.set('file', file);
  if (sourceUrl) form.set('sourceUrl', sourceUrl);
  const res = await fetch(`${BACKEND}/documents/ingest`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: form,
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body?.detail || body?.error || `dépôt échoué (${res.status})`);
  return body;
}
